import { render, staticRenderFns } from "./group-notifications.vue?vue&type=template&id=e44bc660&scoped=true&"
import script from "./group-notifications.vue?vue&type=script&lang=js&"
export * from "./group-notifications.vue?vue&type=script&lang=js&"
import style0 from "./group-notifications.vue?vue&type=style&index=0&id=e44bc660&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e44bc660",
  null
  
)

export default component.exports